module.exports = __webpack_public_path__ + "c52b5b1c1b85bd5c072672b4478744b1.jpg";